import React, { CSSProperties } from "react"
import autobind from "class-autobind"
import FontIcon from "material-ui/FontIcon"
import ToolTip from "react-portal-tooltip"
import strings from "../../localization/strings"
import { IPunchDocument } from "../../models"
import AccountStore from "../../stores/AccountStore"
import MapLoader from "../../components/map/MapLoader"
import { grey600, grey400 } from "material-ui/styles/colors"
interface IProps {
    punch: IPunchDocument
    toolTipKey?: string
    iconStyle?: CSSProperties
}
interface IState {
    open: boolean
    centerPosition: { lat: number, lng: number }
    locationName: string
}

export default class PunchMapToolTipColumn extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        const hierarchy = AccountStore.getCurrentAccount().HierarchyItems.find(item => item.Id === props.punch.HierarchyItemId)
        this.state = {
            open: false,
            centerPosition: {
                lat: props.punch.MetaData && props.punch.MetaData.Latitude,
                lng: props.punch.MetaData && props.punch.MetaData.Longitude
            },
            locationName: hierarchy ? hierarchy.Label : "",
        }
        autobind(this)
    }

    isNoDeviceLocation() {
        const punchExceptions = this.props.punch.PunchExceptions
        if (punchExceptions && punchExceptions.length > 0) {
            const locationPunchException = punchExceptions.find((item) => item.Type === "NO_DEVICE_LOCATION")
            return locationPunchException ? true : false
        } else {
            return false
        }
    }

    render() {
        const showLocationMap = this.props.punch.MetaData && (this.props.punch.MetaData.Latitude !== 0 || this.props.punch.MetaData.Longitude !== 0)
        const isNoDeviceLocation = this.isNoDeviceLocation()
        return (
            <div>
                <ToolTip
                    active={this.state.open}
                    position="right"
                    arrow="center"
                    parent={`#punch-map-${this.props.toolTipKey ? this.props.toolTipKey : ""}-${this.props.punch.Id}`}
                    tooltipTimeout={50}
                >
                    {!this.props.punch.ImageID && !showLocationMap ?
                        <div style={{ width: 320, height: 75, textAlign: "center" }}>
                            <h3>{strings.No_Location}</h3>
                            {this.props.punch.DeviceId ? strings.Punch_added_GPS_off : strings.Punch_added_manually}
                        </div> :
                        !isNoDeviceLocation && showLocationMap ?
                            <div style={{ width: 300, height: 300 }}>
                                <section style={{ height: "100%" }}>
                                    <MapLoader locations={[this.state.centerPosition]} key={this.props.punch.ImageID} />
                                </section>
                            </div> :
                            <div
                                style={{
                                    width: 320,
                                    height: showLocationMap && !isNoDeviceLocation ? 350 : 150,
                                    textAlign: "center"
                                }}
                            >
                                <h3>{strings.Device_Location_not_found}</h3>
                                <b>{strings.Ensure_following_on_mobile_device}</b>
                                <div style={{ textAlign: "left" }}>
                                    <ul>
                                        <li>{strings.GPS_is_enabled}</li>
                                        <li>{strings.WIFI_is_on}</li>
                                        <li>{strings.Location_enabled_Findd_app}</li>
                                    </ul>
                                </div>
                                {showLocationMap && !isNoDeviceLocation &&
                                    <div>{this.state.locationName} Location</div>
                                }
                                {showLocationMap && !isNoDeviceLocation &&
                                    <section style={{ height: "50%" }}>
                                        <MapLoader locations={[this.state.centerPosition]} />
                                    </section>
                                }
                            </div>
                    }
                </ToolTip>
                <FontIcon
                    data-intercom-target={`MapColumn-${this.props.punch && this.props.punch.Id}-Btn-OpenMapTooltip`}
                    className="fa fa-globe"
                    style={{ color: this.props.punch.ImageID ? grey600 : grey400, ...this.props.iconStyle }}
                    id={`punch-map-${this.props.toolTipKey ? this.props.toolTipKey : ""}-${this.props.punch.Id}`}
                    onClick={() => this.setState({ open: !this.state.open })}
                    onMouseOut={() => this.setState({ open: false })}
                />
            </div>
        )
    }
}
